module.exports = __webpack_public_path__ + "static/img/bubble-vertical-inverse.e95a593.png";